import { darken } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { getTypographyFromTheme } from '../../../../../../../../../../utils/theme/getTypographyFromTheme';

const GRID_SLOT_BUTTON_HEIGHT = 28;

const useOrderProductGridButtonStyles = makeStyles()((theme) => {
  const typographyBody2 = getTypographyFromTheme(theme.typography.body2);

  return {
    button: {
      minWidth: 60,
      maxWidth: 82,
      borderRadius: theme.shape.borderRadiusMd,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(0.5),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      ...typographyBody2,
      color: theme.palette.text.secondary,
      height: GRID_SLOT_BUTTON_HEIGHT,
    },
    defaultBackgroundColor: {
      backgroundColor: theme.palette.secondary.dark,
      '&:hover': {
        backgroundColor: darken(theme.palette.secondary.dark, 0.05),
      },
      '&:active': {
        backgroundColor: darken(theme.palette.secondary.dark, 0.1),
      },
    },
    errorIcon: {
      color: theme.palette.error.main,
      marginLeft: theme.spacing(0.5),
    },
    icon: {
      marginLeft: theme.spacing(0.25),
    },
    pastedIcon: {
      marginRight: 2,
    },
    pasteButton: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      width: 'fit-content',
      paddingRight: '4px',
      '&:hover': { background: theme.palette.primary.dark },
    },
    pastedButton: {
      backgroundColor: theme.palette.action.selected,
      color: theme.palette.text.secondary,
      padding: '0px 6px',
    },
    copiedGrid: {
      color: theme.palette.text.primary,
      border: `1.5px dashed ${theme.palette.accent.main}`,
      backgroundColor: theme.palette.secondary.light,
      columnGap: '2px',
      paddingRight: 4,
      '&:hover': { backgroundColor: theme.palette.secondary.dark },
    },
    invalidPasteButton: {
      color: theme.palette.divider,
      border: `1px solid ${theme.palette.divider}`,
      paddingRight: 4,
    },
    endMobileBaseButton: {
      borderRadius: 8,
    },
    endBaseButton: {
      width: 45,
      minWidth: 45,
      height: 30,
      borderRadius: 8,
      color: '#6C6C6C',
    },
  };
});

export default useOrderProductGridButtonStyles;
